import { INSURERS_RECEIVED } from '../constants';

export default function insurersReducer(state = [], action) {
  switch (action.type) {
    case INSURERS_RECEIVED: {
      if (action.payload.value.hasOwnProperty('results')) {
        return action.payload.value.results;
      }

      return [action.payload.value];
    }

    default:
      return state;
  }
}
